import { render, staticRenderFns } from "./ListPermit.vue?vue&type=template&id=67e8a92f&lang=pug&"
import script from "./ListPermit.vue?vue&type=script&lang=js&"
export * from "./ListPermit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports